import styled, { css } from "styled-components";

// Base glass mixin - moze se koristiti i van komponenti
export const glassMixin = css`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.12);
`;

export const glassLightMixin = css`
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.5);
`;

// =====================
// GLASS PANEL - osnovni container
// =====================
export const GlassPanel = styled.div`
  ${({ $variant }) => ($variant === "light" ? glassLightMixin : glassMixin)}
  border-radius: ${({ theme, $radius }) => $radius || theme.borderRadius.xl};
  padding: ${({ theme, $padding }) => $padding || theme.spacing.xl};
  transition: all ${({ theme }) => theme.transitions.normal};

  ${({ $hover }) =>
    $hover &&
    css`
      &:hover {
        background: rgba(255, 255, 255, 0.14);
        border-color: rgba(255, 255, 255, 0.2);
        transform: translateY(-2px);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
      }
    `}
`;

// =====================
// GLASS CARD - za yacht listings, feature cards itd
// =====================
export const GlassCard = styled.div`
  ${({ $variant }) => ($variant === "light" ? glassLightMixin : glassMixin)}
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  overflow: hidden;
  transition: all ${({ theme }) => theme.transitions.normal};

  &:hover {
    background: ${({ $variant }) =>
      $variant === "light"
        ? "rgba(255, 255, 255, 0.75)"
        : "rgba(255, 255, 255, 0.14)"};
    border-color: ${({ $variant }) =>
      $variant === "light"
        ? "rgba(255, 255, 255, 0.6)"
        : "rgba(255, 255, 255, 0.22)"};
    transform: translateY(-4px);
    /* box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15); */
  }
`;

export const GlassCardImage = styled.div`
  position: relative;
  overflow: hidden;
  aspect-ratio: ${({ $ratio }) => $ratio || "16 / 10"};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }

  ${GlassCard}:hover & img {
    transform: scale(1.05);
  }
`;

export const GlassCardBody = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
  min-width: 0;

  @media (max-width: 640px) {
    padding: ${({ theme }) => theme.spacing.lg};
  }
`;

// =====================
// GLASS TAG / BADGE
// =====================
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;
export const GlassTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: ${({ theme }) => theme.fonts.caps};
  font-size: 8px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  letter-spacing: ${({ theme }) => theme.letterSpacings.wider};
  text-transform: uppercase;
  padding: 6px 14px 6px 11px;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  color: ${({ theme }) => theme.colors.white};
  background: rgba(26, 35, 50, 0.55);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.22);

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.primaryLight};
    flex-shrink: 0;
  }

  ${({ $variant }) =>
    $variant === "success" &&
    css`
      background: rgba(20, 60, 40, 0.45);
      border-color: rgba(76, 175, 130, 0.35);

      &::before {
        background: ${({ theme }) => theme.colors.success};
        box-shadow: 0 0 0 0 rgba(76, 175, 130, 0.6);
        animation: tagPulse 2.2s ease-in-out infinite;
      }

      @keyframes tagPulse {
        0% {
          box-shadow: 0 0 0 0 rgba(76, 175, 130, 0.55);
        }
        70% {
          box-shadow: 0 0 0 6px rgba(76, 175, 130, 0);
        }
        100% {
          box-shadow: 0 0 0 0 rgba(76, 175, 130, 0);
        }
      }
    `}

  ${({ $variant }) =>
    $variant === "featured" &&
    css`
      background: rgba(26, 35, 50, 0.55);
      border-color: rgba(201, 169, 110, 0.45);

      &::before {
        background: ${({ theme }) => theme.colors.gold};
        box-shadow: 0 0 8px rgba(201, 169, 110, 0.55);
      }
    `}

  ${({ $variant }) =>
    $variant === "uponRequest" &&
    css`
      background: rgba(26, 35, 50, 0.55);
      border-color: rgba(201, 169, 110, 0.3);

      &::before {
        background: ${({ theme }) => theme.colors.gold};
      }
    `}

  ${({ $variant }) =>
    $variant === "primary" &&
    css`
      background: rgba(26, 35, 50, 0.62);
      border-color: rgba(255, 255, 255, 0.16);

      &::before {
        background: ${({ theme }) => theme.colors.primaryLight};
      }
    `}

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 4px 10px 4px 8px;
    font-size: 10px;
    gap: 6px;

    &::before {
      width: 5px;
      height: 5px;
    }
  }
`;

// =====================
// GLASS INPUT
// =====================
export const GlassInput = styled.input`
  width: 100%;
  padding: 14px 20px;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.white};
  ${glassMixin}
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  outline: none;
  transition: all ${({ theme }) => theme.transitions.normal};

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  &:focus {
    background: rgba(255, 255, 255, 0.14);
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(112, 141, 171, 0.15);
  }
`;

// =====================
// GLASS BUTTON
// =====================
export const GlassButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.sm};
  font-family: ${({ theme }) => theme.fonts.caps};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  letter-spacing: ${({ theme }) => theme.letterSpacings.wider};
  text-transform: uppercase;
  padding: 14px 32px;
  color: ${({ theme }) => theme.colors.white};
  ${glassMixin}
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  transition: all ${({ theme }) => theme.transitions.normal};

  &:hover {
    background: rgba(255, 255, 255, 0.18);
    border-color: rgba(255, 255, 255, 0.25);
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;

// =====================
// GLASS DIVIDER
// =====================
export const GlassDivider = styled.hr`
  border: none;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.15),
    transparent
  );
  margin: ${({ theme, $margin }) => $margin || `${theme.spacing.xl} 0`};
`;

// =====================
// GLASS NAVBAR (helper za Navbar component)
// =====================
export const glassNavMixin = css`
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
`;

export const glassNavScrolledMixin = css`
  background: rgba(26, 35, 50, 0.82);
  backdrop-filter: blur(28px);
  -webkit-backdrop-filter: blur(28px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.2);
`;
